import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';

const Footer = () => (
    <Stack direction="row" padding="8px" spacing={6} alignItems="center">
        <a href="https://grew-bancroft.or.jp/" target="_blank" rel="noreferrer">
            <img
                src="https://grew-bancroft.or.jp/wp/wp-content/themes/grew/images/common/logo.png"
                width="260"
                alt="Grew Bancroft Foundation"
            />
        </a>
        <Stack sx={{ fontSize: '80%' }}>

            <Link
                href="tel:0334086343"
                target="_blank"
                rel="noopener"
                color="inherit"
                underline="hover"
            >Tel・Fax 03-5443-1136</Link>
            <Link
                href="https://goo.gl/maps/c4LZnv8tWPFSJpqa8"
                target="_blank"
                rel="noopener"
                color="inherit"
                underline="hover"
            >東京都港区南麻布2-8-21 SNUG MINAMI-AZABU 301</Link>
            <Link
                href="https://grew-bancroft.or.jp/privacy/"
                target="_blank"
                rel="noopener"
                color="inherit"
                underline="hover"
            >個人情報保護方針</Link>
        </Stack>
    </Stack>
);

export default Footer;